import { CustomColumn } from '../../../../../../types/components/tables/tableTypes';
import {
  SupplementaryRulesFirstTableRow,
  SupplementaryRulesPayload,
  SupplementaryRulesSecondTableConfig,
  SupplementaryRulesSecondTableRow,
} from '../../../../../../api/rs-hg/risk/supplementaryRules.types';


export function buildSecondLevelColumns(
  secondTable: SupplementaryRulesSecondTableConfig,
): CustomColumn<SupplementaryRulesSecondTableRow>[] {
  return secondTable.columns
    .map((column) => ({
      title: column.column_header,
      field: column.column_key,
      headerStyle: {
        backgroundColor: 'rgb(232, 232, 232)',
        borderBottom: '1px solid #446699',
        textAlign: 'left'
      },
      cellStyle: {
        backgroundColor:
          column.type === 'row_number'
            ? 'rgba(68, 101, 151, 0.35)'
            : 'rgb(232, 232, 232)',
        borderBottom: '1px solid #446699',
        transition:
          column.column_key === 'exposure_pc' ||
          column.column_key === 'exposure'
            ? 'all .5s'
            : undefined,
        textAlign: 'left'
      },
    }));
}

export function buildSecondaryData(
  rowData: SupplementaryRulesFirstTableRow,
  supplementaryRulesData: SupplementaryRulesPayload,
  secondTable: SupplementaryRulesSecondTableConfig,
) {
  const relevantParam = String(rowData[secondTable.parentMatchField] ?? '');
  const positions = supplementaryRulesData.positions || [];

  return positions
    .filter((position) => {
      const impactedRules = position[secondTable.childMatchField];
      return Array.isArray(impactedRules) && impactedRules.includes(relevantParam);
    })
    .map((position, index) => {
      const tableRow: SupplementaryRulesSecondTableRow = {
        number: index + 1,
      };

      secondTable.columns.forEach((column) => {
        if (column.type === 'row_number') {
          tableRow[column.column_key] = index + 1;
          return;
        }

        if (column.formatter) {
          tableRow[column.column_key] = column.formatter(position, index);
          return;
        }

        if (column.sourceKey) {
          const value = position[column.sourceKey];
          tableRow[column.column_key] =
            typeof value === 'string' || typeof value === 'number'
              ? value
              : null;
        }
      });

      return tableRow;
    });
}
